import React from 'react';
import TermsConditions from '../components/TermsConditions';

const TermsConditionsPage = () => {
  return (
    <>
      <TermsConditions />
    </>
  );
};

export default TermsConditionsPage;
